export const LANG = {
  END_OF_LIST: 'Đã hết danh sách, lên đầu trang'
};
